import React, { Component } from "react";

import "./Footer.scss";

export default class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      connStatus: navigator.onLine,
    };
  }

  componentDidMount = () => {
    window.addEventListener("offline", () => {
      this.setState(() => ({ connStatus: false }));
    });

    window.addEventListener("online", () => {
      this.setState(() => ({ connStatus: true }));
    });
  };

  render() {
    const year = new Date().getFullYear();

    return (
      <footer className="footer">
        <div className="footer__colophon">
          <div className="outerContainer np flex flex-wrap flex-justify-between">
            <div className="content footer__colophonInnerLeft container">
              <p>&#169; {year} DMS International. All Rights Reserved.</p>
            </div>
            <div className={`container`}>
              <p className={`${this.state.connStatus ? "online" : "offline"}`}>
                <span className="connStatusDot" />
                {this.state.connStatus ? "Online" : "Offline"}
              </p>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
